import { Routes } from '@angular/router';

import { provideRedeemeeHttp } from './core/http/provide-redeemee-http';
import { adminLoginGuestGuard } from './features/admin-login/admin-login.guest.guard';
import { merchantLoginGuestGuard } from './features/merchant-login/merchant-login.guest.guard';

export const routes: Routes = [
  {
    path: 'merchant/login',
    canActivate: [merchantLoginGuestGuard],
    providers: [provideRedeemeeHttp()],
    loadComponent: () =>
      import('./features/merchant-login/merchant-login-page.component').then(
        (m) => m.MerchantLoginPageComponent,
      ),
  },
  {
    path: 'admin/login',
    canActivate: [adminLoginGuestGuard],
    providers: [provideRedeemeeHttp()],
    loadComponent: () =>
      import('./features/admin-login/admin-login-page.component').then(
        (m) => m.AdminLoginPageComponent,
      ),
  },
  {
    path: '',
    loadComponent: () =>
      import('./core/layout/main-layout.component').then((m) => m.MainLayoutComponent),
    providers: [provideRedeemeeHttp()],
    children: [
      {
        path: '',
        loadChildren: () =>
          import('./features/home/home.routes').then((m) => m.HOME_ROUTES),
      },
      {
        path: 'merchants',
        loadChildren: () =>
          import('./features/merchants/merchants.routes').then(
            (m) => m.MERCHANTS_ROUTES,
          ),
      },
      {
        path: 'campaigns',
        loadChildren: () =>
          import('./features/campaigns/campaigns.routes').then(
            (m) => m.CAMPAIGNS_ROUTES,
          ),
      },
      {
        path: 'users',
        loadChildren: () =>
          import('./features/users/users.routes').then((m) => m.USERS_ROUTES),
      },
    ],
  },
];
